import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Service Request Table (/service-request)
 */
export const serviceRequestTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_SRTable_Welcome_Title"),
    description: t("Tour_SRTable_Welcome_Description"),
    target: () => queryTourTarget("sr-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_SRTable_Status_Title"),
    description: t("Tour_SRTable_Status_Description"),
    target: () => queryTourTarget("sr-status-filter"),
    placement: "bottom",
  },
  {
    title: t("Tour_SRTable_Create_Title"),
    description: t("Tour_SRTable_Create_Description"),
    target: () => queryTourTarget("sr-create"),
    placement: "left",
  },
];
